<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Trxhd8/tc-custom/9781439663004.jpg?1705026122763" alt="This image is the cover for the book San Luis Obispo County Outlaws, True Crime"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">San Luis Obispo County Outlaws, True Crime
      </h1>
      <p class="bookDescription body article font2">
        <p>California was a wild and lawless place in the 1850s, and San Luis Obispo County was no exception. Outlaws and bandits passed along the El Camino Real, now Highway 101, leaving a trail of victims. Despite attempts to stem the tide of crime with a vigilante committee and a string of executions, notorious men continued to be drawn to the central coast well into the next century. The James brothers, the Daltons and even Al Capone made their mark here, while lawmen worked to tame this piece of the western frontier. Author Jim Gregory details nefarious activities lost to time.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jim Gregory
      </h2>
      
      <p class="authorDescription body article">This is longtime Arroyo Grande resident Jim Gregory's third book on local history, following World War II Arroyo Grande and Patriot Graves: Discovering a California Town's Civil War Heritage. Gregory attended local schools, including the two-room Branch School in the Upper Arroyo Grande Valley; Cuesta College; the University of Missouri, where he received a degree in history; and Cal Poly, where he received his teaching credential. He taught for thirty years at Mission Prep in San Luis Obispo and at Arroyo Grande High School. He was Lucia Mar's Teacher of the Year in 2010-11 and began writing upon his retirement in 2015. Gregory is married to Elizabeth, campus minister and teacher at St. Joseph High School in Santa Maria, and the father of sons John and Thomas.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f3caf80e